import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { AnimationModal } from '../AnimationModal';
import * as Styled from './styles';

const preventBackgroundScrolling = prevent => {
    document.body.style.overflow = prevent ? 'hidden' : 'unset';
};

const RevealSelectionAnimation = ({ title, entry, animationRunTimeInMs }) => {
    const [hide, setHide] = useState(false);

    const name = get(entry, 'name', null);

    if (entry.name) {
        localStorage.setItem('has_seen_entry', JSON.stringify(true));
    }

    const metaData = get(entry, 'metaData', {});
    const clothNumber = get(metaData, 'clothNumber', null);
    const jockeyName = get(metaData, 'jockeyName', null);
    const trainerName = get(metaData, 'trainerName', null);
    const silk = get(metaData, 'silk', null);

    useEffect(() => {
        preventBackgroundScrolling(true);

        setTimeout(() => {
            setHide(true);
            preventBackgroundScrolling(false);
        }, animationRunTimeInMs);
    });

    return (
        <CSSTransition
            in={!hide}
            appear
            timeout={500}
            classNames="fade"
            unmountOnExit
        >
            <Styled.FadeAnimation>
                <AnimationModal
                    title={title}
                    horseName={name}
                    clothNumber={clothNumber}
                    jockeyName={jockeyName}
                    trainerName={trainerName}
                    silk={silk}
                />
            </Styled.FadeAnimation>
        </CSSTransition>
    );
};

RevealSelectionAnimation.defaultProps = {
    entry: {},
    animationRunTimeInMs: 6000 // milliseconds
};

RevealSelectionAnimation.propTypes = {
    title: PropTypes.string.isRequired,
    entry: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        metaData: PropTypes.shape({
            clothNumber: PropTypes.string,
            jockeyName: PropTypes.string,
            trainerName: PropTypes.string,
            silk: PropTypes.string
        })
    }),
    animationRunTimeInMs: PropTypes.number
};

export default RevealSelectionAnimation;
